module.exports = __webpack_public_path__ + "img/picto-EV 1.eb773890.svg";